import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { classNames, selectors, events } from "./ef-nav.constants";
import { addClass, removeClass, staggerTransitions, breakpoints } from "../utils/helpers";
import { EventHandler } from "../utils/events";
import { bpEvents } from "../utils/breakpoints";
import { EfCollapsible } from "../ef-collapsible/ef-collapsible";
export var EfNav = /*#__PURE__*/function () {
  function EfNav(el) {
    var _this = this;

    _classCallCheck(this, EfNav);

    this._el = el;
    this._events = EventHandler;
    this._bodyEl = document.body;
    this._headerEl = this._bodyEl.querySelector(selectors.HEADER);
    this._navToggle = document.body.querySelector(selectors.NAVTOGGLE);
    this._navItems = _toConsumableArray(this._el.querySelectorAll(selectors.NAVITEM));
    this._navCollapsibles = _toConsumableArray(this._el.querySelectorAll(".ef-collapsible__toggle"));
    this._collapsibleInstances = null;
    this._isOpen = false;

    this._boundToggle = function (evt) {
      return _this.toggle(evt);
    };

    this._breakpointHandle = this._breakpointHandler.bind(this);

    this._init();
  }

  _createClass(EfNav, [{
    key: "toggle",
    value: function toggle() {
      this._isOpen = !this._isOpen;

      this._setOpen(this._isOpen);
    }
  }, {
    key: "show",
    value: function show() {
      this._isOpen = true;

      this._setOpen(this._isOpen);
    }
  }, {
    key: "hide",
    value: function hide() {
      this._isOpen = false;

      this._setOpen(this._isOpen);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._collapsibleInstances && this._collapsibleInstances.forEach(function (el) {
        return el.destroy();
      });

      this._events.off(this._navToggle, "click", this._boundToggle);

      this._events.off(document, bpEvents.UPDATED, this._breakpointHandle);

      this.hide();
    }
  }, {
    key: "_init",
    value: function _init() {
      this._breakpointHandle(breakpoints.current);

      this._events.on(document, bpEvents.UPDATED, this._breakpointHandle);
    }
  }, {
    key: "_breakpointHandler",
    value: function _breakpointHandler(bp) {
      if (typeof bp === "object") bp = bp.detail;

      if (bp === "s") {
        this._setup();
      } else {
        this.destroy();
      }
    }
  }, {
    key: "_setup",
    value: function _setup() {
      this._collapsibleInstances = this._navCollapsibles && this._navCollapsibles.map(function (el) {
        return new EfCollapsible(el, {
          breakpoints: ["s"]
        });
      });

      this._events.on(this._navToggle, "click", this._boundToggle);

      this._navItems && staggerTransitions(this._navItems);
    }
  }, {
    key: "_setOpen",
    value: function _setOpen(bool) {
      bool ? this._open() : this._close();
    }
  }, {
    key: "_open",
    value: function _open() {
      addClass(this._bodyEl, classNames.BODYHASOPENNAV);
      addClass(this._headerEl, classNames.HEADEROPEN);
      addClass(this._navToggle, classNames.NAVACTIVE);
      addClass(this._el, classNames.NAVACTIVE);

      this._events.trigger(this._el, events.SHOWN);
    }
  }, {
    key: "_close",
    value: function _close() {
      removeClass(this._bodyEl, classNames.BODYHASOPENNAV);
      removeClass(this._headerEl, classNames.HEADEROPEN);
      removeClass(this._navToggle, classNames.NAVACTIVE);
      removeClass(this._el, classNames.NAVACTIVE);

      this._events.trigger(this._el, events.HIDDEN);
    }
  }]);

  return EfNav;
}();